import {DocumentNode, gql} from "@apollo/client";

export const UPDATE_MASTER_ADDRESS_MUTATION: DocumentNode = gql(`
    mutation UpdateMasterAddress($dto: UserMasterAddressRequest!, $tfaCode: String) {
        updateMasterAddress(updateMasterAddressDTO: $dto, tfaCode: $tfaCode) {
            ...MasterAddressInfo
        }
    }
`);
